import { exportPriceStatusOptions } from './Filters/ExportPriceFilter/constants'

export const isValidHSCode = hsCode => {
  const hsCodeRegex = /^(\d{6,10})$/

  return hsCodeRegex.test(hsCode)
}

export const isValidBarcode = barcode => {
  const barcodeRegex = /^\d{8,}$/

  return barcodeRegex.test(barcode)
}

const isKnownExportPriceStatus = status => exportPriceStatusOptions.some(option => option.value === status)

const getExportPriceParam = hasExportPrice => {
  const knownStatuses = hasExportPrice?.filter(isKnownExportPriceStatus)

  if (knownStatuses?.length !== 1) return {}

  return { has_export_price: knownStatuses[0] }
}

const getExportPriceCountryParam = exportPriceCountry => {
  if (!exportPriceCountry?.length) return {}

  return { export_price_country: exportPriceCountry }
}

export const getInventoryRequestParams = params => {
  const { has_export_price: hasExportPrice, export_price_country: exportPriceCountry, ...requestParams } = params

  return {
    ...requestParams,
    ...getExportPriceParam(hasExportPrice),
    ...getExportPriceCountryParam(exportPriceCountry),
  }
}
